module.exports = __webpack_public_path__ + "img/ax.79429621.svg";